import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { CAMPAIGN } from "../lib/campaign";

export default function CopyCode({ className = "", compact = false }) {
  const [copied, setCopied] = useState(false);
  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { await navigator.clipboard.writeText(CAMPAIGN.code); } catch (_) {}
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  if (compact) {
    return (
      <button type="button" onClick={copy} data-testid="copy-code-compact" aria-label="Kopiera rabattkod" className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-[#ffce3a] text-[#0B2545] font-extrabold tracking-[0.15em] hover:bg-white transition-colors ${className}`}>
        {copied ? <><Check size={11} /> Kopierad!</> : CAMPAIGN.code}
      </button>
    );
  }
  return (
    <button type="button" onClick={copy} data-testid="copy-code-btn" className={`group/copy w-full flex items-center justify-between gap-3 rounded-2xl border-2 border-dashed px-4 py-3 text-left transition-colors ${copied ? "border-emerald-400 bg-emerald-50" : "border-[#0B2545]/25 bg-[#f6f9fc] hover:border-[#0B2545]/50 hover:bg-[#fffbea]"} ${className}`}>
      <span className="flex items-center gap-3">
        <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-slate-500">Rabattkod</span>
        <span className="font-display text-2xl font-black tracking-[0.2em] text-[#0B2545]" data-testid="campaign-code">{CAMPAIGN.code}</span>
      </span>
      <span className={`inline-flex items-center gap-1.5 text-xs font-bold ${copied ? "text-emerald-700" : "text-slate-500 group-hover/copy:text-[#0B2545]"}`} data-testid="copy-code-status">
        {copied ? <><Check size={14} /> Kopierad!</> : <><Copy size={14} /> Kopiera</>}
      </span>
    </button>
  );
}
